<template>
  <vis-loading :loading="isSyncronizing" :defaultStyle="defaultLoadingStyle">
    <div class="ba-h-full">
      <div
        class="ba-flex ba-flex-no-wrap ba-w-full ba-h-full ba-font-wellingtons-regular"
      >
        <aside class="ba-flex-srink-0 ba-min-w-89">
          <div
            class="ba-mr-2 ba-overflow-y-auto"
            :class="[
              pagination ? 'ba-h--full-12 ba-mb-4' : 'ba-h-full ba-mb-0',
            ]"
          >
            <vis-docmail-list
              :docmail-list="docmailList"
              @onItemSelect="onDocumentListItemSelect"
            />
          </div>
          <div
            class="ba-flex ba-justify-center ba-text-sm ba-font-inter-regular"
          >
            <button
              :title="$t('documentFlow.syncEmailsButtonText')"
              :disabled="isSyncronizing"
              type="button"
              class="ba-flex ba-justify-center ba-items-center ba-w-8 ba-h-8 ba-mr-2 ba-leading-none ba-select-none ba-opacity-90 hover:ba-opacity-100"
              @click="onSyncMessages"
            >
              <i class="fal fa-sync" />
            </button>

            <!-- PAGINATION ============================================= -->
            <vis-docmail-pagination
              v-if="pagination"
              :mails-count="mailsCount"
              :skip-value="skipValue"
              @nextPageClick="onNextPageClick"
              @previousPageClick="onPreviousPageClick"
            />
          </div>
        </aside>
        <!-- =================================================== -->
        <div class="ba-flex-1 ba-h-ful">
          <vis-docmail-body
            v-if="documentItem"
            :document-item="documentItem"
            @showModal="onShowModal"
            @delete="onDelete"
          />
        </div>
      </div>
      <!-- MODAL ============================================= -->
      <vis-docmail-modal
        v-if="documentItem"
        v-model="visibleModal"
        @onCreate="onDocumentCreate"
        :documents="documentItem.files"
      />
      <!-- =================================================== -->
      <vis-detail-view-dialog
        v-if="crudService !== null"
        :context="{}"
        :crud-service="crudService"
        :visible="detailViewVisible"
        @save="onDetailViewSave"
        @hide="onDetailViewHide"
        :readonly="false"
      />
    </div>
  </vis-loading>
</template>

<script>
import VisDocmailModal from "./vis-docmail-modal-design";
import VisDocmailList from "./vis-docmail-list-design";
import VisDocmailBody from "./vis-docmail-body-design";
import VisDocmailPagination from "./vis-docmail-pagination-design";
import api from "@/api/visary-api";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import errorMessage from "@/shared/error-message";

export default {
  name: "vis-docmail-design",
  components: {
    VisDocmailModal,
    VisDocmailList,
    VisDocmailBody,
    VisDocmailPagination,
  },
  data() {
    return {
      visibleModal: false,
      detailViewVisible: false,
      pagination: true,
      docmailList: [],
      documentItem: null,
      mailsCount: 0,
      skipValue: 0,
      crudService: null,
      isSyncronizing: false,
      defaultLoadingStyle: {
        height: "100% !important",
        overflow: "hidden",
      },
    };
  },
  methods: {
    async onNextPageClick() {
      this.skipValue += 10;
      await this.setDocumentEmails();
    },
    async onPreviousPageClick() {
      this.skipValue -= 10;
      await this.setDocumentEmails();
    },
    onDetailViewSave() {
      this.detailViewVisible = false;
      this.documentItem.unread = false;
      for (var i = 0; i < this.docmailList.length; i++) {
        if (this.docmailList[i].id === this.documentItem.id) {
          this.docmailList[i].unread = false;
        }
      }
    },
    onDetailViewHide() {
      this.detailViewVisible = false;
    },
    async onDocumentCreate(e) {
      this.crudService = new RemoteCrudService(e.type);
      this.crudService.setId(0);
      this.crudService.addDefaultValue("Files", e.mainDocument);
      this.crudService.addDefaultValue("AdditionalFiles", e.otherDocs);
      this.crudService.addDefaultValue("DocumentEmail", {
        ID: this.documentItem.id,
        Title: this.documentItem.theme,
      });
      this.detailViewVisible = true;
      this.visibleModal = false;
    },
    onShowModal() {
      this.visibleModal = true;
    },
    async onDelete() {
      let result = await api.documentFlow.deleteEmail(this.documentItem.id);
      this.docmailList = this.docmailList.filter(o => o.id !== this.documentItem.id);
      this.documentItem = null;
    },
    async onDocumentListItemSelect(id) {
      this.documentItem = await api.documentFlow.getDocumentEmail(id);
    },
    async setDocumentEmails() {
      let result = await api.documentFlow.getDocumentEmails(this.skipValue, 10);
      this.mailsCount = result.count;
      this.docmailList = result.data.map((x) => {
        let filesList = (x.documents || "").split(",").filter(function (s) {
          return !!s;
        });
        return Object.assign(x, {
          files: filesList,
        });
      });
      if (this.docmailList.length > 0) {
        this.documentItem = await api.documentFlow.getDocumentEmail(
          this.docmailList[0].id
        );
      }
    },
    async onSyncMessages() {
      if (this.isSyncronizing) return;

      this.isSyncronizing = true;
      try {
        await api.documentFlow.syncMessages();
        await this.setDocumentEmails();
      } catch (ex) {
        const error = await errorMessage(ex);
        this.$visNotification.show(error.title, error.message, "danger");
      } finally {
        this.isSyncronizing = false;
      }
    },
  },
  async created() {
    await this.setDocumentEmails();
  },
};
</script>

